module.exports = "<footer class=\"app-footer\">\n  <a href=\"http://coreui.io\">Jointly</a> &copy; 2017 creativeLabs.\n  <span class=\"float-right\">Powered by <a href=\"http://coreui.io\">Jointly</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main